import React from "react";

/**
 * Reusable inline alert banner for error, success, info, and warning messages.
 *
 * @param {"error"|"success"|"info"|"warning"} [variant="error"]
 * @param {React.ReactNode} children - Banner content
 * @param {string} [className] - Extra classes (e.g. spacing overrides)
 */

const VARIANT_STYLES = {
  error:
    "bg-fill-red-50 dark:bg-fill-red-900/20 border border-edge-red-200 dark:border-edge-red-800 text-ink-red-600 dark:text-ink-red-400",
  success:
    "bg-fill-green-50 dark:bg-fill-green-900/20 border border-edge-green-200 dark:border-edge-green-800 text-ink-green-700 dark:text-ink-green-400",
  info:
    "bg-fill-blue-50 dark:bg-fill-blue-900/20 border border-edge-blue-200 dark:border-edge-blue-800 text-ink-blue-700 dark:text-ink-blue-300",
  warning:
    "bg-fill-yellow-50 dark:bg-fill-yellow-900/20 border border-edge-yellow-200 dark:border-edge-yellow-800 text-ink-yellow-700 dark:text-ink-hex-fde047",
};

const AlertBanner = ({ variant = "error", children, className = "" }) => (
  <div
    className={`photon-alert p-4 rounded-lg text-sm ${VARIANT_STYLES[variant] || VARIANT_STYLES.error} ${className}`}
    data-variant={variant}
    role="alert"
  >
    {children}
  </div>
);

export default AlertBanner;
